module.exports = __webpack_public_path__ + "img/Bear31.1529158f.jpg";